export default "__VITE_ASSET__668ccb01__"